import { DateRange, PickersShortcutsItem } from '@mui/x-date-pickers-pro';
import { add, endOfYear, startOfMonth, startOfYear, sub } from 'date-fns';

function createCommonShortcuts(excludeToday: boolean): PickersShortcutsItem<DateRange<Date>>[] {
    const offset = excludeToday ? 1 : 0;

    return [
        {
            label: 'Last 7 Days',
            getValue: () => {
                const today = new Date();
                return [sub(today, { days: 7 + offset }), sub(today, { days: offset })];
            }
        },
        {
            label: 'Current Month',
            getValue: () => {
                const today = new Date();
                const end = sub(today, { days: offset });
                const start = excludeToday ? sub(startOfMonth(today), { days: 1 }) : startOfMonth(today);
                return [start, end];
            }
        },
        {
            label: 'Last 30 Days',
            getValue: () => {
                const today = new Date();
                return [sub(today, { days: 30 + offset }), sub(today, { days: offset })];
            }
        },
        {
            label: 'Last 3 Months',
            getValue: () => {
                const today = new Date();
                const start = excludeToday
                    ? sub(today, { months: 3, days: 1 })
                    : add(sub(today, { months: 3 }), { days: 1 });
                return [start, sub(today, { days: offset })];
            }
        }
    ];
}

export const defaultRangeShortcutsItems: PickersShortcutsItem<DateRange<Date>>[] = [
    {
        label: 'Today',
        getValue: () => {
            const today = new Date();
            return [today, today];
        }
    },
    {
        label: 'Yesterday',
        getValue: () => {
            const yesterday = sub(new Date(), { days: 1 });
            return [yesterday, yesterday];
        }
    },
    ...createCommonShortcuts(false),
    { label: 'Reset', getValue: () => [null, null] }
];

// all the shortcuts should exclude "today", due to the data flow, until platform fixes it
export const ANALYTICS_DATE_RANGE_SHORTCUTS: PickersShortcutsItem<DateRange<Date>>[] = [
    ...createCommonShortcuts(true),
    {
        label: 'This Year',
        getValue: () => {
            const today = new Date();
            return [startOfYear(today), sub(today, { days: 1 })];
        }
    },
    {
        label: 'Last Year',
        getValue: () => {
            const today = new Date();
            const start = startOfYear(sub(today, { years: 1 }));
            return [start, endOfYear(start)];
        }
    }
];
